import { atom, useRecoilState } from 'recoil';

interface SortState {
  by: string;
  direction: string;
}

interface FiltersState {
  created_at_start: string | null;
  created_at_end: string | null;
  sort_by: string;
  sort_direction: string;
}

const sortState = atom<SortState>({
  key: 'ConnectedUsersSort',
  default: {
    by: 'connected_since',
    direction: 'desc',
  },
});

const filtersState = atom<FiltersState>({
  key: 'ConnectedUsersFilters',
  default: {
    created_at_start: null,
    created_at_end: null,
    sort_by: 'connected_since',
    sort_direction: 'desc',
  },
});

export const useSort = (): [
  { direction: string; by: string },
  (sort: string) => void
] => {
  const [{ direction, by }, setSort] = useRecoilState(sortState);
  const [, setFilters] = useRecoilState(filtersState);

  return [
    { direction, by },
    (sort: string) => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc';
        setSort({ by: sort, direction: newDirection });
        setFilters(prev => ({ ...prev, sort_by: sort, sort_direction: newDirection }));
      } else {
        setSort({ by: sort, direction: 'asc' });
        setFilters(prev => ({ ...prev, sort_by: sort, sort_direction: 'asc' }));
      }
    },
  ];
};

export const useFilters = (): [
  FiltersState,
  React.Dispatch<React.SetStateAction<FiltersState>>
] => {
  return useRecoilState(filtersState);
};